<template>
  <div class="container">
    <van-tabs v-model="currentTab" @change="switchCoupons" animated swipeable sticky>
      <van-tab :title="item.name" v-for="(item, index) in tabs" :key="index">
        <div class="coupons">
          <div class="coupon" :class="setCouponClass(myCoupon)" v-for="(myCoupon, idx) in myCoupons" :key="idx">
            <div class="coupon-hd">
              <div class="coupon-price" v-if="myCoupon.coupon.types === 'money_off'">
                <span>{{myCoupon.coupon.moneyOffAmount}}</span>元
              </div>
              <div class="coupon-price" v-if="myCoupon.coupon.types === 'discount'">
                <span>{{myCoupon.coupon.discount / 10}}</span>折
              </div>
              <div class="coupon-info">
                <div class="coupon-info__title van-ellipsis">{{myCoupon.coupon.title}}</div>
                <div class="coupon-info__desc">指定部分课程使用，详见使用范围</div>
              </div>
            </div>
            <div class="coupon-bd">
              <div class="coupon-expire">有效期：{{$moment(myCoupon.endAt).format('YYYY-MM-DD HH:mm')}}</div>
              <div class="coupon-range" v-if="myCoupon.status === 'unused'" @click="showRange(myCoupon)">使用范围</div>
              <div class="coupon-btn" v-if="myCoupon.status === 'unused'" @click="toUse(myCoupon)">去使用</div>
            </div>
            <div class="coupon-expire__icon" v-if="myCoupon.status === 'expired'">
              <img :src="require('@/assets/images/expired_img.png')" alt="">
            </div>
          </div>
        </div>
        <Empty :show="myCoupons.length === 0" text="暂无优惠券" />
      </van-tab>
    </van-tabs>
    <van-popup class="range-popup" v-model="showRangePopup" :close-on-click-overlay="false">
      <div class="popup">
        <img class="popup-bg" :src="require('@/assets/images/coupon_range_bg.png')" alt="">
        <div class="popup-close" @click="showRangePopup = false"><van-icon name="cross" color="#fff" /></div>
        <div class="popup-title van-ellipsis">{{currentCoupon.title}}</div>
        <div class="popup-content">
          <div class="subject" v-for="(item, index) in currentCoupon.subjects" :key="index" @click="toSubject(item.id)">
            <div class="subject-index">{{index + 1}}</div>
            <div class="subject-name van-ellipsis">{{item.title}}</div>
            <van-icon name="arrow" color="#ff8700" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getUserCoupons } from './query.gql'
import Empty from '@/components/Empty'
export default {
  name: 'coupon',
  components: {
    Empty
  },
  data() {
    return {
      currentTab: 0,
      tabs: [{
        type: 'unused',
        name: '可使用'
      }, {
        type: 'used',
        name: '已使用'
      }, {
        type: 'expired',
        name: '已过期'
      }],
      myCoupons: [],
      currentCoupon: {},
      showRangePopup: false
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.getMyCoupons()
  },
  methods: {
    // 切换tab
    switchCoupons(index) {
      this.getMyCoupons(this.tabs[index].type)
    },
    // 点击使用范围
    showRange(myCoupon) {
      this.currentCoupon = myCoupon.coupon
      this.showRangePopup = true
    },
    // 设置优惠券class
    setCouponClass(myCoupon) {
      let className = ''
      if (myCoupon.status === 'unused') {
        switch (myCoupon.coupon.types) {
          case 'money_off':
            className = 'coupon-moneyoff'
            break
          case 'discount':
            className = 'coupon-discount'
            break
        }
      } else {
        className = 'coupon-disabled'
      }
      return className
    },
    // 获取用户优惠券
    getMyCoupons(couponType = 'unused') {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getUserCoupons,
        fetchPolicy: 'no-cache',
        variables: { couponType }
      }).then(res => {
        self.myCoupons = res.data.userCoupons
        self.$toast.clear()
      }).catch(err => {
        console.error('page：coupon/index。请求getUserCoupons报错', err)
        self.$toast.clear()
        self.$toast.fail('加载数据出错')
      })
    },
    // 跳转到详情页
    toSubject(id) {
      this.$router.push({
        name: 'subject',
        query: { id }
      })
    },
    toUse(item) {
      if (item.coupon.subjects.length === 1) {
        this.$router.push({
          name: 'subject',
          query: {
            id: item.coupon.subjects[0].id
          }
        })
      } else {
        this.$router.replace({
          name: 'home'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .coupons{
    padding: 25px 15px 0;
    .coupon{
      border-radius: 6px;
      margin-bottom: 20px;
      overflow: hidden;
      position: relative;
      .coupon-hd{
        display: flex;
        padding: 8px 8px 8px 20px;
        align-items: center;
        .coupon-price{
          color: #ff5825;
          text-shadow: 0px 1px 0px #f00;
          width: 72.5px;
          height: 72.5px;
          line-height: 72.5px;
          border-radius: 50%;
          font-size: 15px;
          font-weight: bold;
          box-sizing: border-box;
          display: flex;
          align-items: baseline;
          justify-content: center;
          background: url('~@/assets/images/available_price_box.png') no-repeat center / 100%;
          span{
            font-size: 45px;
          }
        }
        .coupon-info{
          margin-left: 24px;
          color: #fff;
          .coupon-info__title{
            font-size: 20px;
            font-weight: bold;
            width: 220px;
          }
          .coupon-info__desc{
            font-size: 14px;
            padding-top: 10px;
          }
        }
      }
      .coupon-bd{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px 10px;
        .coupon-expire{
          font-size: 11px;
          color: #808080;
        }
        .coupon-range{
          color: #01a2ff;
          font-size: 12px;
          text-decoration: underline;
        }
        .coupon-btn{
          width: 70px;
          height: 25px;
          line-height: 25px;
          border-radius: 15px;
          color: #fff;
          font-size: 15px;
          text-align: center;
          background: #ff6701;
          text-shadow: 2px 2px 4px #ff3d01;
        }
      }
      .coupon-expire__icon{
        width: 63px;
        height: 63px;
        position: absolute;
        bottom: 5px;
        right: 10px;
        img{
          width: 100%;
          display: block;
        }
      }
      &.coupon-discount{
        box-shadow: 1px 0px 13px 4px #f5faff;
        .coupon-hd{
          background: url('~@/assets/images/coupon_bg_3.png') no-repeat center / 100%;
          .coupon-info{
            text-shadow: 2px 2px 0px #4191fe;
          }
        }
      }
      &.coupon-moneyoff{
        box-shadow: 1px 0px 13px 4px #fbeee6;
        .coupon-hd{
          background: url('~@/assets/images/coupon_bg_1.png') no-repeat center / 100%;
          .coupon-info{
            text-shadow: 2px 2px 0px #ff7a23;
          }
        }
      }
      &.coupon-disabled{
        box-shadow: 1px 0px 13px 4px #f6f6f6;
        .coupon-hd{
          background: url('~@/assets/images/already_used_coupon_bg.png') no-repeat center / 100%;
          .coupon-price{
            background-image: url('~@/assets/images/already_used_price_box.png');
            color: #fff;
            text-shadow: none;
          }
          .coupon-info{
            text-shadow: 2px 2px 0px #797979;
          }
        }
      }
    }
  }
  .range-popup{
    background: none;
    .popup{
      position: relative;
      .popup-bg{
        width: 300px;
      }
      .popup-close{
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 9;
      }
      .popup-title{
        position: absolute;
        left: 30px;
        right: 30px;
        top: 17px;
        font-size: 29px;
        font-weight: bold;
        text-align: center;
        color: #fff;
        text-shadow: 4px 1px 1px #ff8216;
        z-index: 7;
      }
      .popup-content{
        border-radius: 15px;
        background: #fff;
        overflow: auto;
        position: absolute;
        top: 87.5px;
        left: 15px;
        right: 15px;
        bottom: 50px;
        z-index: 8;
        padding: 10px 12px;
        .subject{
          display: flex;
          align-items: center;
          .subject-index{
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            border-radius: 9px;
            font-size: 15px;
            font-weight: bold;
            color: #fff;
            background: #ff8700;
            margin-right: 7px;
          }
          .subject-name{
            height: 38.5px;
            line-height: 38.5px;
            font-size: 14px;
            color: #333;
            flex: 1;
          }
        }
      }
    }
  }
</style>
